<div class="course-container mt-5 pt-5 mx-3 row">
  <div class="col-12 col-lg-3 left-card">
    <h1 class="m-3 mb-4">{{ data.courseName }}</h1>

    <p-accordion [activeIndex]="lesson ? lesson.currentChapterIndex : 0">
      <p-accordionTab *ngFor="let item of data.courseList" [header]="item.title" >
        <div
          class="d-flex align-items-center pt-2 pointer"
          *ngFor="let detail of item.lessons"
          (click)="openLesson(detail)"
          [ngStyle]="{ 'color': detail.name == (lesson ? lesson.name : '') ? 'purple' : '' }"
        >
          <i
            class="fs-5"
            [ngClass]="
              detail.played
                ? 'bi bi-check-circle-fill text-success'
                : 'bi bi-play-circle'
            "
          ></i>
          <h6 class="px-2 m-0 font-style">{{ detail.name }}</h6>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div *ngIf="lesson" class="col-12 col-lg-9">
    <video width="100%" height="500" controls controlsList="nodownload" [src]="lesson.video"></video>
    <div class="d-flex justify-content-between m-3">
      <h4>{{ lesson.name }}</h4>
      <div class="d-flex gap-3">
        <span class="pointer" *ngIf="lesson.nextLesson" (click)="openLesson(lesson.nextLesson)">&#10094;</span>
        <span class="pointer" *ngIf="lesson.prevLesson" (click)="openLesson(lesson.prevLesson)">&#10095;</span>
      </div>
    </div>
  </div>
</div>
